/**
 * Stock-Sales — format helpers + number coerce.
 * Mirror VBA cleanNumber/cleanCheck/Format("Standard")/Format("DD-MMM-YYYY").
 */
import dayjs from 'dayjs'

export function toNumber(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0
  const n = typeof value === 'number' ? value : Number(String(value).replace(/,/g, ''))
  return Number.isFinite(n) ? n : 0
}

export function formatStandard(value: unknown): string {
  const n = toNumber(value)
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatInteger(value: unknown): string {
  const n = toNumber(value)
  return Math.round(n).toLocaleString('en-US')
}

export function formatAccessDate(value: unknown): string {
  if (!value) return ''
  const d = dayjs(value as string | number | Date)
  return d.isValid() ? d.format('DD-MMM-YYYY') : ''
}

export function formatAccessDateTime(value: unknown): string {
  if (!value) return ''
  const d = dayjs(value as string | number | Date)
  return d.isValid() ? d.format('DD-MMM-YYYY HH:mm') : ''
}

export function toIsoDate(value: unknown): string {
  if (!value) return ''
  const d = dayjs(value as string | number | Date)
  return d.isValid() ? d.format('YYYY-MM-DD') : ''
}
